(ns app.front.view.inspections.checklists.subs
  (:require [app.domain.inspection.model :as inspection-model]
            [app.front.process :as process]
            [app.front.ui.section :as section]
            [app.front.view.inspections.deficiencies-v2 :as deficiencies-v2]
            [app.front.view.inspections.visit :as-alias inspection-visit]
            [app.front.view.navigation :as navigation]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.event :refer [<sub]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::scroll-to-deficiencies-section
  (fn [_ _]
    {:dispatch [::navigation/scroll-to-id (section/get-section-id deficiencies-v2/deficiencies-section-id)]}))

(rf/reg-event-fx ::confirm-checklist-completed
  (fn [_ [_ target-entity-id inspection-id checklist-id]]
    {:dispatch [::process/signal target-entity-id [:process.signal/confirm-checklist-completed
                                                   (util/mmap inspection-id checklist-id)]
                {:on-success [::scroll-to-deficiencies-section]
                 :notify     {:success :inspection/checklist-completed}}]}))


(rf/reg-sub ::default-checklist-ids
  :<- [::inspection-visit/current-inspection]
  (fn [inspection _]
    (->> inspection
         :inspection/template
         :entity/parent
         :inspection.template.kind/default-checklist-templates
         (map :db/id)
         set)))

(rf/reg-sub ::checklist-templates
  :<- [:language]
  :<- [::inspection-visit/current-inspection]
  :<- [::default-checklist-ids]
  (fn [[lang current-inspection default-checklist-ids] _]
    (let [templates         (-> current-inspection
                                :inspection/template
                                :entity/parent
                                inspection-model/checklist-templates)
          template-sort-fn  #(-> (:inspection.checklist/names %)
                                 (i18n-model/get-text-from-entities-or-map lang)
                                 str/lower-case)
          default-templates (->> templates
                                 (filter #(default-checklist-ids (:db/id %)))
                                 (sort-by template-sort-fn))
          other-templates   (->> templates
                                 (remove #(default-checklist-ids (:db/id %)))
                                 (sort-by template-sort-fn))]
      (concat default-templates other-templates))))

(rf/reg-sub ::add-permitted?
  :<- [::inspection-visit/current-inspection]
  (fn [inspection _]
    (<sub [::process/signal-permitted?
           (-> inspection :entity/parent :db/id)
           [:process.signal/add-checklist-to-inspection {:inspection-id (:db/id inspection)}]])))

(rf/reg-sub ::remove-permitted?
  :<- [::inspection-visit/current-inspection]
  (fn [inspection [_ {:db/keys [id]}]]
    (<sub [::process/signal-permitted?
           (-> inspection :entity/parent :db/id)
           [:process.signal/remove-checklist-from-inspection {:inspection-id (:db/id inspection)
                                                              :checklist-id  id}]])))

(rf/reg-sub ::complete-permitted?
  :<- [::inspection-visit/current-inspection]
  (fn [inspection [_ {:db/keys [id]}]]
    (<sub [::process/signal-permitted?
           (-> inspection :entity/parent :db/id)
           [:process.signal/confirm-checklist-completed {:inspection-id (:db/id inspection)
                                                         :checklist-id  id}]])))
